/**
 * Shopify install flow data must survive navigation across tabs (e.g. embedded app → login in new tab).
 * Mirror critical keys to localStorage while keeping sessionStorage for same-tab reads.
 */

export const SHOPIFY_INSTALL_STORAGE_KEYS = {
  signupMetadata: 'shopify_signup_metadata',
  pendingConnection: 'shopify_pending_connection',
  shop: 'shopify_shop',
  host: 'shopify_host',
  wizard: 'shopify_install_wizard',
  tokenExchangeError: 'shopify_token_exchange_error',
} as const;

/** Redirect target after embedded Shopify OAuth connect (existing Scubamail users). */
export function shopifyEmbeddedPath(shopDomain?: string | null): string {
  const shop = (shopDomain || readShopifyInstallStorage(SHOPIFY_INSTALL_STORAGE_KEYS.shop) || '').trim();
  return shop ? `/shopify/embedded?shop=${encodeURIComponent(shop)}` : '/shopify/embedded';
}

export function readShopifyInstallStorage(key: string): string | null {
  if (typeof window === 'undefined') return null;
  try {
    return sessionStorage.getItem(key) ?? localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function writeShopifyInstallStorage(key: string, value: string): void {
  if (typeof window === 'undefined') return;
  try {
    sessionStorage.setItem(key, value);
    localStorage.setItem(key, value);
  } catch {
    /* noop */
  }
}

export function removeShopifyInstallStorage(key: string): void {
  if (typeof window === 'undefined') return;
  try {
    sessionStorage.removeItem(key);
    localStorage.removeItem(key);
  } catch {
    /* noop */
  }
}
